import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseAdjustmentsSearch } from "@/features/money";
import { AdjustmentsPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/adjustments/")({
  validateSearch: strictSearch(parseAdjustmentsSearch),
  component: Adjustments,
});

function Adjustments() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <AdjustmentsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
      hrefOf={(adjustmentId) =>
        router.buildLocation({ to: "/money/adjustments/$adjustmentId", params: { adjustmentId } })
          .href
      }
      onOpen={(adjustmentId) =>
        void router.navigate({ to: "/money/adjustments/$adjustmentId", params: { adjustmentId } })
      }
    />
  );
}
